import  gql  from 'graphql-tag'

export const SHARE_FM102_EMAIL = gql`mutation shareFm102ByEmail($input: ShareFM102ByEmailMutationInput!){
    shareFm102ByEmail(input: $input){
        errors{
            field
            messages
        }
    }
}`;